export const GENERATE_REPORT = {
  START: "GENERATE_REPORT_START",
  SUCCESS: "GENERATE_REPORT_SUCCESS",
  ERROR: "GENERATE_REPORT_ERROR",
};

export const FETCH_CUSTOMERS = {
  START: "FETCH_CUSTOMERS_START",
  SUCCESS: "FETCH_CUSTOMERS_SUCCESS",
  ERROR: "FETCH_CUSTOMERS_ERROR",
};

export const TOAST = {
  RESET: "TOAST_RESET",
};
